<template>
  <div
    :class="{ 'rt-list-header-shadow': shadow,'rt-list-header-small':small,'rt-list-header-hide-bg':hiddenBg,'rt-list-header-no-border':noBorder }"
    class="rt-list-header"
  >
    <div class="rt-list-header-top">
      <div
        v-if="!!$slots.icon || !!$scopedSlots.icon"
        class="header-icon"
      >
        <slot name="icon" />
      </div>
      <div class="header-content">
        <div
          v-if="hasIcon"
          :class="iconClass"
        >
          <rt-icon
            :name="icon"
            :img-src="iconSrc"
            :size="32"
          />
        </div>
        <slot />
      </div>
      <div class="header-btns">
        <slot name="btn" />
      </div>
      <div class="header-search">
        <slot name="search" />
      </div>
      <div
        v-if="hasBack"
        class="header-back"
      >
        <slot name="back">
          <rt-button
            class="rt-btn-back"
            icon-name="rt-base-back"
            @click="$router.back"
          >
            {{
              $tx('返回', 'xpc.detailheader.back')
            }}
          </rt-button>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import RtButton from '../../button/rtButton';
import RtIcon from '../../icon/rtIcon.vue';
export default {
  name: 'RtListHeader',
  components: { RtButton, RtIcon },
  props: {
    icon: {
      type: String,
      default: ''
    },
    iconSrc: {
      type: String,
      default: ''
    },
    iconBgColor: {
      type: String,
      default: 'warning'
    },
    showBack: {
      type: Boolean,
      default: false
    },
    shadow: {
      type: Boolean,
      default: true
    },
    small: {
      type: Boolean,
      default: false
    },
    hiddenBg: {
      type: Boolean,
      default: false
    },
    noBorder: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasIcon () {
      return !!this.icon || !!this.iconSrc;
    },
    hasBack () {
      return !!this.showBack || !!this.$slots.back;
    },
    iconClass () {
      const className = ['rt-list-header-icon'];
      const themeColor = ['primary', 'primary', 'normal', 'success', 'warning', 'danger', 'info'];
      if (themeColor.includes(this.iconBgColor)) {
        className.push(`bg-color-${this.iconBgColor}`);
      }
      return className;
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtListHeader.vue?20885466